import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Popup, { PopupTrigger } from '@aytm/lib/rfd-ui/components/basic/popup'

import '@aytm/lib/rfd-ui/styles/basic/text-popup.scss'

export default class TextPopup extends Component {
  static propTypes = {
    trigger: PropTypes.string,
    text: PropTypes.string,
    content: PropTypes.string
  }

  constructor(...args) {
    super(...args);
    this.renderContent = this.renderContent.bind(this);
  }

  renderContent() {
    const { content } = this.props

    return <div dangerouslySetInnerHTML={{ __html: content }} />
  }

  render() {
    const { trigger = 'hover', text, ...props } = this.props
    return (
      <PopupTrigger trigger={trigger}>
        <Popup
          width="350px"
          className="rfd-ui-popup-notification"
          direction="topright"
          headerCloseButton={false}
          {...props}
          content={this.renderContent}
        >
          <span className="rfd-ui-popup-notification-link" dangerouslySetInnerHTML={{ __html: text }} />
        </Popup>
      </PopupTrigger>
    )
  }
}
